import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useFacts } from "./useFacts";
import { Divider } from "@gemini/ui";
import { Fact } from "./Fact";
export const Facts = () => {
    const facts = useFacts();
    if (!facts)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Box, { display: {
                    "breakpoint.base": "grid",
                    "breakpoint.md": "flex",
                }, gridTemplateColumns: "repeat(2, 1fr)", gap: "spacing.16", children: facts.map((fact) => (_jsx(Fact, { Icon: fact.Icon, label: fact.label, value: fact.value, splitValue: fact.splitValue }, fact.value))) }), _jsx(Divider, { marginVertical: "spacing.16", "aria-hidden": "true" })] }));
};
